import React, { useEffect, useState } from 'react'
import ReactSVG from 'react-svg'
import useTranslation from 'next-translate/useTranslation'

export const ShippingAndPaymentInfo = () => {
	const { t } = useTranslation('common')

	return (
		<section className='vehicle-part-shipping-and-payment-info'>

			<div className='vehicle-part-shipping-and-payment-info__item'>
				<ReactSVG src='/icons/dostava.svg' beforeInjection={(svg) => {
					svg.setAttribute('width', '40px')
					svg.setAttribute('height', '40px')
				}} />
				<div className='vehicle-part-shipping-and-payment-info__item-text'>
					<p>{t('dostava')}</p>
					<p>{t('za-sve-gradove-cg')}</p>
				</div>
			</div>

			<div className='vehicle-part-shipping-and-payment-info__item'>
				<ReactSVG src='/icons/placanje-kuriru.svg' beforeInjection={(svg) => {
					svg.setAttribute('width', '40px')
					svg.setAttribute('height', '40px')
				}} />
				<div className='vehicle-part-shipping-and-payment-info__item-text'>
					<p>{t('placanje')}</p>
					<p>{t('pri preuzimanju')}</p>
				</div>
			</div>

			<div className='vehicle-part-shipping-and-payment-info__item'>
				<ReactSVG src='/icons/zamjena-povrat-robe.svg' beforeInjection={(svg) => {
					svg.setAttribute('width', '35px')
					svg.setAttribute('height', '35px')
				}} />
				<div className='vehicle-part-shipping-and-payment-info__item-text'>
					<p>{t('Zamjena')}</p>
					<p>{t('prema uslovima')}</p>
				</div>
			</div>



			<div className='vehicle-part-shipping-and-payment-info__item'>
				<ReactSVG src='/icons/sigurnost.svg' beforeInjection={(svg) => {
					svg.setAttribute('width', '35px')
					svg.setAttribute('height', '35px')
				}} />
				<div className='vehicle-part-shipping-and-payment-info__item-text'>
					<p>{t('Sigurnost')}</p>
					<p>{t('zaštita potrošača')}</p>
				</div>
			</div>
		</section>
	)
}